import React, {useEffect} from 'react';
import {FmlxButton, FmlxTab} from 'fmlx-common-ui';
import TableEmployee from './TableEmployee';
import {FMLX_BUTTON, FMLX_COMPONENT} from '../../const/FmlxComponentEnum';
import ModalCreateUpdateEmployee from './ModalCreateUpdateEmployee';
import {ModalType, TabId} from './enum';
import {resetState, setSelectedTab} from '../../stores/actions/manageEmployeeAction';
import {manageEmployeeSelector} from '../../stores/selectors/manageEmployeeStateSelector';
import {getInitialData, openModal} from '../../stores/business/manageEmployeeBusiness';
import {useDispatch, useSelector} from 'react-redux';
import './ManageEmployee.scss';

const ManageEmployee = () => {
  const {selectedTab} = useSelector(manageEmployeeSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getInitialData());
    return () => {
      /** reset manage employee redux state to null to improve performance */
      dispatch(resetState());
    }
  }, [dispatch]);

  const onRegisterEmployeeClickHandler = async () => {
    await dispatch(openModal(ModalType.CREATE));
  }

  return (
    <div className='manage-employee'>
      <FmlxButton
        id={"btnRegisterEmployee"}
        size={FMLX_COMPONENT.SIZE.M}
        type={FMLX_BUTTON.TYPE.PRIMARY}
        variant={FMLX_BUTTON.VARIANT.CONTAIN}
        label="Register Employee"
        onClick={onRegisterEmployeeClickHandler}
        withTooltip={false}
        tooltipPlacement={"top"}
        tooltipDescription={"Register Employee"}
      />
      <FmlxTab
        id='manage-employee--tab'
        selectedTab={selectedTab}
        items={[
          {
            title: 'Active Employee',
            icon: null,
            disabled: false,
            content: selectedTab === TabId.ACTIVE_EMPLOYEE ? <TableEmployee tableId={TabId.ACTIVE_EMPLOYEE}/> : <></>,
          },
          {
            title: 'Inactive Employee',
            icon: null,
            disabled: false,
            content: selectedTab === TabId.INACTIVE_EMPLOYEE ?
              <TableEmployee tableId={TabId.INACTIVE_EMPLOYEE}/> : <></>,
          },
        ]}
        variant={FmlxTab.Variant.FULLWIDTH}
        orientation={FmlxTab.Orientation.HORIZONTAL}
        onChange={({index}) => {
          dispatch(setSelectedTab(index))
        }}
      />
      <ModalCreateUpdateEmployee/>
    </div>
  );
};

ManageEmployee.propTypes = {};

ManageEmployee.defaultProps = {};

export default ManageEmployee;
